import { render, staticRenderFns } from "./SocialTooltip.vue?vue&type=template&id=54592319&scoped=true&"
import script from "./SocialTooltip.vue?vue&type=script&lang=ts&"
export * from "./SocialTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SocialTooltip.vue?vue&type=style&index=0&id=54592319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54592319",
  null
  
)

export default component.exports